import { formatDistanceToNow } from "date-fns";
import { MdDelete } from "react-icons/md";
import { GoReply } from "react-icons/go";

const CommentCard = ({ el, user, deleteComment, handleReply, i, id }) => {
  return (
    <div className="bg-white dark:bg-black text-black dark:text-white p-6 relative">
      <div className="flex justify-between items-start mb-6 border-b-2 border-dashed border-gray-300 dark:border-gray-700 pb-4">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 border border-black dark:border-white/30 bg-gray-100 dark:bg-[#111] flex-shrink-0">
            {el.user_id?.avatar ? (
              <img
                alt={el.user_id?.name || "avatar"}
                src={el.user_id.avatar}
                className="w-full h-full object-cover grayscale"
              />
            ) : (
              <span className="flex items-center justify-center w-full h-full text-black dark:text-white font-black font-mono uppercase">
                {el.user_id?.name?.charAt(0) || "U"}
              </span>
            )}
          </div>

          <div className="flex flex-col">
            <span className="font-mono font-black text-black dark:text-white text-sm uppercase tracking-widest leading-none mb-1">
              {el.user_id?.name}
            </span>
            <span className="text-[10px] font-mono tracking-widest text-gray-500 whitespace-nowrap uppercase font-bold">
              LOGGED:{" "}
              {formatDistanceToNow(new Date(el.createdAt), {
                addSuffix: true,
              })}
            </span>
          </div>
        </div>

        {el.user_id?.email === user?.user?.email && (
          <button
            onClick={() => deleteComment(el._id, id)}
            className="p-2 border border-black dark:border-white/30 text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
            title="Purge Record"
          >
            <MdDelete className="text-lg" />
          </button>
        )}
      </div>

      <p className="text-black dark:text-white font-mono text-sm leading-relaxed whitespace-pre-wrap uppercase font-bold pl-4 border-l-4 border-gray-200 dark:border-gray-700">
        {el.message}
      </p>

      <div className="mt-6 flex items-center justify-between">
        <button
          onClick={() => handleReply(i)}
          className="flex items-center gap-2 px-4 py-2 text-[10px] font-black uppercase tracking-widest text-black dark:text-white border border-black dark:border-white/30 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)] active:shadow-none dark:active:shadow-none active:translate-x-0.5 active:translate-y-0.5"
        >
          <GoReply className="text-[14px]" />
          INITIATE REPLY
        </button>
      </div>
    </div>
  );
};

export default CommentCard;
